import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

// API base: REACT_APP_API_URL, or api.phiprinting.com when on phiprinting.com, or same-origin /api for localhost
function getApiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window === 'undefined') return 'https://api.phiprinting.com/api';
  const origin = window.location.origin;
  if (origin === 'https://phiprinting.com' || origin === 'https://www.phiprinting.com') {
    return 'https://api.phiprinting.com/api';
  }
  return `${origin}/api`;
}
const apiBaseUrl = getApiBaseUrl();
export const API_BASE = apiBaseUrl.replace(/\/api\/?$/, '');

const api: AxiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Get or create session ID for guest users
export const getSessionId = (): string => {
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
};

// Add token to requests if available
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
} else {
  // Add session ID for guest users
  const sessionId = getSessionId();
  api.defaults.headers.common['X-Session-Id'] = sessionId;
}

// Interceptor to update session ID when token changes
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    delete config.headers['X-Session-Id'];
  } else {
    const sessionId = getSessionId();
    config.headers['X-Session-Id'] = sessionId;
    delete config.headers['Authorization'];
  }
  
  // Log request details for debugging
  const fullUrl = `${config.baseURL}${config.url}`;
  console.log(`[API Request] ${config.method?.toUpperCase()} ${fullUrl}`, {
    baseURL: config.baseURL,
    url: config.url,
    fullURL: fullUrl,
    params: config.params,
    data: config.data
  });
  
  return config;
});

// Response interceptor for error logging
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config) {
      const fullUrl = `${error.config.baseURL}${error.config.url}`;
      console.error(`[API Error] ${error.config.method?.toUpperCase()} ${fullUrl}`, {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        fullURL: fullUrl
      });
    }
    return Promise.reject(error);
  }
);

export default api;

